import { StyledCross } from './Cross.styles';
interface Props {
  onClick: () => void;
  'data-testid'?: string;
  width?: string;
  height?: string;
  margin?: string;
}

export const Cross = ({ onClick, width, height, margin, ...props }: Props) => (
  <StyledCross
    onClick={onClick}
    data-testid={props['data-testid']}
    margin={margin}
  >
    <img
      width={width}
      height={height}
      src="/assets/close-icon-grey.svg"
      alt="Close"
    />
  </StyledCross>
);
